import { useIntl } from 'react-intl'

import logo_cs from '../../assets/images/logo/logo_cs_crop.png?format=webp'
import logo_en from '../../assets/images/logo/logo_en_crop.png?format=webp'

export const useLogo = () => {
    const intl = useIntl()

    return intl.locale === 'cs-CZ' ? logo_cs : logo_en
}